// Eager-Teil der Registry: Navigation aus apps/web/src/modules/<key>/meta.ts (Besitzer: geruest).
import { MODULE_KEYS } from '@bar/contracts/modules';
import type { ModuleMeta, NavItem, PlatformKey, Viewer } from './types';
import { matchesAudience } from './visibility';

const files = import.meta.glob<{ default: ModuleMeta }>('../modules/*/meta.ts', { eager: true });

const order = (key: string) => (MODULE_KEYS as readonly string[]).indexOf(key);

/** Alle Modul-Metadaten in der Reihenfolge von MODULE_KEYS. */
export const MODULE_METAS: readonly ModuleMeta[] = Object.values(files)
  .map((file) => file.default)
  .sort((a, b) => order(a.key) - order(b.key));

/** Navigationseinträge einer Plattform, die der Viewer sehen darf, sortiert nach `order`. */
export function navItemsFor(
  platform: PlatformKey,
  viewer: Viewer,
  metas = MODULE_METAS,
): NavItem[] {
  return metas
    .flatMap((meta) => meta.nav?.[platform] ?? [])
    .filter((item) => matchesAudience(item.roles, viewer))
    .sort((a, b) => a.order - b.order);
}

/** Admin-Navigation gruppiert nach Bereich (Reihenfolge der Bereiche wie UX §2.7). */
export const ADMIN_AREAS = [
  'Overview',
  'People ops',
  'Performance',
  'Rewards',
  'Cases',
  'Tech',
  'Knowledge',
  'System',
] as const;

export function adminNavSections(viewer: Viewer, metas = MODULE_METAS) {
  const items = navItemsFor('admin', viewer, metas);
  return ADMIN_AREAS.map((area) => ({
    area,
    items: items.filter((item) => item.area === area),
  })).filter((section) => section.items.length > 0);
}
